<label class="confirmo-checkbox-container">
  <ng-content></ng-content>
  <span>
    {{ label }} <span *ngIf="warning" class="confirmo-checkbox-warning">{{ warning }}</span>
  </span>
</label>
